import fssaiLogo from "../../../assets/images/FSSAI_logo.webp";

const ProductInfo = () => {
  return (
    <>
      <div className="border border-gray-100 rounded-16 mt-16 overflow-hidden">
        <div className="row g-0 align-items-stretch">
          <div className="col-sm-5">
            <div className="p-24 h-100 border-end border-gray-100">
              <h6 className="text-sm fw-bold text-heading mb-8 text-uppercase">
                Storage Instructions
              </h6>
              <p className="text-gray-600 text-sm mb-0">
                Store under refrigeration at 4°C or below, in hygienic
                conditions.
              </p>
            </div>
          </div>
          <div className="col-sm-7">
            <div className="p-24">
              <h6 className="text-sm fw-bold text-heading mb-8 text-uppercase">
                Marketed By
              </h6>
              <p className="text-gray-600 text-sm mb-0">
                Ground Floor, Ward No. 16, Door No 446B, 446 C,
                <br />
                FUGUS BUILDING, Elbo Road, Puthuvype,
                <br />
                Ernakulam, Kerala - 682508
              </p>
            </div>
          </div>
        </div>
        <div
          className="text-center py-16 px-24"
          style={{
            background: "linear-gradient(135deg, #f0f7ff 0%, #e8f4f8 100%)",
          }}
        >
          <div className="d-inline-flex align-items-center gap-16">
            <img
              src={fssaiLogo}
              alt="FSSAI"
              style={{ height: "40px", width: "auto" }}
            />
            <div className="border-start border-gray-300 ps-16">
              <p className="text-gray-500 text-xs mb-2 fw-medium">
                FSSAI Lic. No.
              </p>
              <p className="text-heading fw-bold mb-0">_________</p>
            </div>
          </div>
        </div>
      </div>
      <div
        className="mt-24 p-20 rounded-16"
        style={{ background: "#fafbfc", border: "1px solid #f0f0f0" }}
      >
        <div className="d-flex align-items-center gap-12">
          <span
            className="w-40 h-40 flex-center rounded-circle text-lg"
            style={{ background: "#e8f5e9", color: "#2e7d32" }}
          >
            <i className="ph-fill ph-shield-check" />
          </span>
          <span className="fw-bold text-gray-900">
            100% Guarantee Safe Checkout
          </span>
        </div>
        <div className="mt-12 ms-52">
          <img
            src="https://marketpro.theme.picode.in/assets/images/thumbs/gateway-img.png"
            alt="Safe Checkout"
            style={{ height: "28px" }}
          />
        </div>
      </div>
    </>
  );
};

export default ProductInfo;
